<script setup lang="ts">
    import {computed} from "vue";
    import {qrcode} from "../util/qrcode";

    const props = defineProps(['text', 'typeNumber', 'errorCorrectionLevel', 'alt'])

    const imgSrc = computed(() => {
        const code = qrcode(props.typeNumber || 0, props.errorCorrectionLevel || 'M')
        code.addData(props.text)
        code.make()
        return code.createDataURL(4 )
    })

</script>

<template>
  <img :src="imgSrc" :alt="alt" /></img>
</template>

<style scoped lang="less">

</style>